import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.history === "undefined") {
      return;
    }

    const originalScrollRestoration = window.history.scrollRestoration;
    try {
      window.history.scrollRestoration = "manual";
    } catch {
      // Ignore browsers that do not support manual scroll restoration
    }

    return () => {
      try {
        window.history.scrollRestoration = originalScrollRestoration || "auto";
      } catch {
        // Ignore browsers that do not support manual scroll restoration
      }
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.search]);

  return null;
};

export default ScrollToTop;

